import { NewStatus } from '@/use-cases/update-certificate';

export const getNewStatusHumanizedName = (newStatus: NewStatus) => {
	switch (newStatus) {
		case 'suspended':
			return 'suspender';
		case 'reactivated':
			return 'reactivar';
		case 'revoked':
			return 'revocar';
	}
};

export const getNewStatusHumanizedNamePastTense = (newStatus: NewStatus) => {
	switch (newStatus) {
		case 'suspended':
			return 'suspendida';
		case 'reactivated':
			return 'reactivada';
		case 'revoked':
			return 'revocada';
	}
};
